import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../constants/services";

export const truckApi = createApi({
	reducerPath: "truckApi",
	baseQuery: dynamicBaseQuery,
	endpoints: (builder) => ({
		getAssets: builder.query<any, void>({
			query: () => ({
				url: "/asset",
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
		getRelatedAssetsWithTags: builder.query<any, void>({
			query: () => ({
				url: "/asset/asset-tag",
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
		getTags: builder.query<any, void>({
			query: () => ({
				url: "https://api.tags.rio.cloud/tags",
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data.items;
				},
			}),
		}),
		getSummary: builder.mutation<any, void>({
			query: (requestPayload) => ({
				url: "/summary",
				method: "POST",
				body: requestPayload,
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
	}),
});

export const { useGetAssetsQuery, useGetRelatedAssetsWithTagsQuery, useGetTagsQuery, useGetSummaryMutation } = truckApi;
